<template>
  <div>
    <PCNavbar selectIndex="17"/>
    <MobileNavBar :currentActive="16" />
    <socialResponsibilityCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import socialResponsibilityCategory from '@/components/service_social_responsibility_category-6/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    socialResponsibilityCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>